import React, { useState } from "react";
import { FaExternalLinkAlt, FaTruckLoading } from "react-icons/fa";
import { elakayAutoText } from "./dataElakay";

// Carrier Tracking iframe -- the Tracking Number modal's "Carrier
// Tracking" view (Order Tracking Display task spec §11/§12). `trackingUrl`
// has already been validated server-side (isTrackingUrlSafe, task spec
// §11) -- `iframeAllowed` tells this component whether embedding is even
// worth attempting; a load failure (X-Frame-Options/CSP, task spec §12)
// falls back to a safe "open in a new tab" link instead of a blank modal.
const TrackingIframe = ({ trackingUrl, iframeAllowed, infoSource }) => {
    const [loadFailed, setLoadFailed] = useState(false);

    const translatedText = (category, key, fallback) => (
        infoSource?.language?.(infoSource, category, key) || fallback
    );

    if (!trackingUrl) {
        return (
            <h2 className="text-center m-3">
                {translatedText("title", "orderprocess", "Order is processing...")}
            </h2>
        );
    }

    const blocked = !iframeAllowed || loadFailed;

    if (blocked) {
        return (
            <div className="tracking-iframe-fallback">
                <span className="tracking-iframe-fallback-icon" aria-hidden="true">
                    <FaTruckLoading />
                </span>
                <p>
                    {elakayAutoText("h_trk_iframe_blocked", "Carrier tracking cannot be displayed inside Elakay.")}
                </p>
                <a
                    className="tracking-iframe-fallback-link"
                    href={trackingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <FaExternalLinkAlt aria-hidden="true" />
                    {elakayAutoText("h_trk_open_carrier", "Open Carrier Tracking Page")}
                </a>
            </div>
        );
    }

    return (
        <iframe
            className="orders-tracking-iframe"
            src={trackingUrl}
            title={translatedText("title", "trackingiframetitle", "Order Tracking")}
            // Best-effort only: a real X-Frame-Options/CSP frame-ancestors
            // block usually renders a blank/browser-error frame rather than
            // firing a DOM "error" event (cross-origin, no signal reaches
            // the parent) -- iframeAllowed (the server-side allowlist
            // check, task spec §11) is the actual defense; this only
            // catches the genuine network-failure case.
            onError={() => setLoadFailed(true)}
        />
    );
};

export default TrackingIframe;
